import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api";
import { SITE as DEFAULT_SITE } from "../data/mock";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(DEFAULT_SITE);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site/settings");
      setSite({ ...DEFAULT_SITE, ...data });
    } catch (e) {
      console.warn("Site settings load failed, using defaults");
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContext.Provider value={{ site, loaded, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
